// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app button{cursor:pointer}.menu-items{list-style:none;margin:0;padding:0 0 1rem;border-bottom:1px solid var(--wb-grey-85)}.menu-items:first-child,.menu-items li{padding-top:1rem}.menu-items a{color:var(--wb-grey-45);text-decoration:none}@media(max-width:47.99em){.menu-items a{margin-bottom:var(--wb-spacing-s)}}", ""]);
// Exports
module.exports = exports;
